<template>
  <div class="crud_form_wrapper">
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.contact_admins") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #266db0">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <div class="row justify-content-center">
            <div class="col-l2">
              <div class="add_another" @click="addRow()">
                <i class="fas fa-plus"></i>
              </div>
            </div>

            <div
              class="col-lg-6 col-12"
              v-for="(item, index) in phones"
              :key="'l' + index"
            >
              <div class="item d-flex align-items-center">
                <base-input
                  class="w-100"
                  type="tel"
                  :placeholder="$t('PLACEHOLDERS.phone')"
                  v-model.trim="item.phone"
                />

                <div class="all_actions">
                  <span
                    class="add_another remove_phone_number"
                    @click="removeRow(index)"
                  >
                    <i class="fas fa-minus"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- Start:: Tax Percentage Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.email')"
            v-model.trim="data.email"
          />
          <!-- End:: Tax Percentage Input -->

          <!-- Start:: Tax Percentage Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.WhatsApp_contact')"
            v-model.trim="data.WhatsApp_contact"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.facebook_link')"
            v-model.trim="data.facebook_link"
          />
          <!-- End:: Tax Percentage Input -->

          <!-- Start:: Tax Percentage Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.twitter_link')"
            v-model.trim="data.twitter_link"
          />
          <!-- End:: Tax Percentage Input -->

          <!-- Start:: Delivery Price Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.tiktok_link')"
            v-model.trim="data.tiktok_link"
          />
          <!-- End:: Delivery Price Input -->

          <!-- Start:: Driver's Daily Orders Amount Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.instagram')"
            v-model.trim="data.instagram_link"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.snap_link')"
            v-model.trim="data.snap_link"
          />
          <!-- End:: Driver's Daily Orders Amount Input -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- End:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "GeneralSettings",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        WhatsApp_contact: null,
        linkedIn_link: null,
        twitter_link: null,
        tiktok_link: null,
        facebook_link: null,
        instagram_link: null,
        snap_link: null,
        android: null,
        ios: null,
        email: null,
      },
      // End:: Data Collection To Send

      phones: [
        {
          phone: "",
        },
      ],
    };
  },

  methods: {
    addRow() {
      this.phones.push({ phone: "" });
    },

    removeRow(index) {
      this.phones.splice(index, 1);
    },

    // Start:: Get Data To Edit
    // async getDataToEdit() {
    //   try {
    //     let res = await this.$axios({
    //       method: "GET",
    //       url: `settings?key=app-contacts`,
    //     });
    //     // Start:: Set Data

    //     // Transform the API response
    //     this.phones = res.data.data[0].value.mobile.map((phone) => ({
    //       phone: phone,
    //     }));

    //     this.data.WhatsApp_contact = res.data.data[0].value.whatsapp;
    //     this.data.twitter_link = res.data.data[0].value?.social?.x;
    //     this.data.instagram_link = res.data.data[0].value?.social?.instagram;

    //     // this.data.tiktok_link = res.data.data[0].value.tiktok;

    //     this.data.email = res.data.data[0].value.email;
    //     this.data.android = res.data.data[0].value.android;
    //     this.data.ios = res.data.data[0].value.ios;
    //     this.data.linkedIn_link = res.data.data[0].value.linkedin;

    //     // End:: Set Data
    //   } catch (error) {
    //     console.log(error.response.data.message);
    //   }
    // },

    // async getDataToEdit() {
    //   try {
    //     let res = await this.$axios({
    //       method: "GET",
    //       url: `settings`,
    //     });
    //     this.data.search_radius = res.data.data.data.find(
    //       (item) => item.key === "app-contacts"
    //     )?.value.;

    //     this.data.min_provider_wallet = res.data.data.data.find(
    //       (item) => item.key === "app-contacts"
    //     )?.value.acceptance_limit_for_providers;

    //     this.data.min_driver_wallet = res.data.data.data.find(
    //       (item) => item.key === "app-contacts"
    //     )?.value.acceptance_limit_for_driver;

    //     this.data.delivery_price_per_km = res.data.data.data.find(
    //       (item) => item.key === "app-contacts"
    //     )?.value.delivery_price_per_km;

    //     this.data.order_expiry_time_delivery_agents = res.data.data.data.find(
    //       (item) => item.key === "app-contacts"
    //     )?.value.order_expiry_time_delivery_agents;

    //     this.data.service_provider_commission = res.data.data.data.find(
    //       (item) => item.key === "app-contacts"
    //     )?.value.admin_commission_on_provider;

    //     this.data.admin_commission_on_driver = res.data.data.data.find(
    //       (item) => item.key === "app-contacts"
    //     )?.value.admin_commission_on_driver;

    //     this.data.time_limit_for_cancel_order = res.data.data.data.find(
    //       (item) => item.key === "app-contacts"
    //     )?.value.time_limit_for_cancel_order;

    //     this.data.subscription_renewal_reminder_period =
    //       res.data.data.data.find(
    //         (item) => item.key === "app-contacts"
    //       )?.value.subscription_renewal_reminder_period;

    //     this.data.tax_percentage = res.data.data.data.find(
    //       (item) => item.key === "app-contacts"
    //     )?.value.tax;
    //   } catch (error) {
    //     console.log(error.response.data.message);
    //   }
    // },

    async getDataToEdit() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `settings`,
        });
        console.log("contact_us", res);

        const info = res.data.data.data.find((el) => el.key == "app-contacts");
        this.phones = info.value?.phones.map((phone) => ({
          phone: phone,
        }));

        this.data.WhatsApp_contact = info.value.watsApp;
        this.data.twitter_link = info.value?.twitter;
        this.data.tiktok_link = info.value?.tiktok;

        this.data.instagram_link = info.value?.instagram;
        this.data.android = info.value?.android;
        this.data.ios = info.value?.ios;

        this.data.email = info.value.email;
        this.data.tiktok_link = info.value.tiktok;
        this.data.snap_link = info.value.snapchat;
        this.data.facebook_link = info.value.facebook;

        // End:: Set Data
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    // End:: Get Data To Edit

    // Start:: Submit Form
    async submitForm() {
      this.isWaitingRequest = !this.isWaitingRequest;

      const REQUEST_DATA = new FormData();
      // Start:: Append Request Data
      REQUEST_DATA.append("key", "app-contacts");
      this.phones.forEach((element, index) => {
        if (element.phone) {
          REQUEST_DATA.append(`value[phones][${index}]`, element.phone);
        }
      });
      if (this.data.WhatsApp_contact) {
        REQUEST_DATA.append("value[watsApp]", this.data.WhatsApp_contact);
      }
      if (this.data.tiktok_link) {
        REQUEST_DATA.append("value[tiktok]", this.data.tiktok_link);
      }
      if (this.data.twitter_link) {
        REQUEST_DATA.append("value[twitter]", this.data.twitter_link);
      }
      if (this.data.facebook_link) {
        REQUEST_DATA.append("value[facebook]", this.data.twitter_link);
      }
      if (this.data.instagram_link) {
        REQUEST_DATA.append("value[instagram]", this.data.instagram_link);
      }
      if (this.data.email) {
        REQUEST_DATA.append("value[email]", this.data.email);
      }
      if (this.data.snap_link) {
        REQUEST_DATA.append("value[snapchat]", this.data.snap_link);
      }

      // Start:: Append Request Data

      try {
        await this.$axios({
          method: "POST",
          url: `settings`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.savedSuccessfully"));
        this.getDataToEdit();
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.submitForm();
    },
    // End:: validate Form Inputs
  },

  created() {
    // Start:: Fire Methods
    this.getDataToEdit();
    // End:: Fire Methods
  },
};
</script>

<style lang="scss" scoped>
.item {
  gap: 10px;
}

.all_action {
  display: flex;
  gap: 15px;
}

.add_another {
  border: none;
  padding: 8px;
  width: 40px;
  height: 40px;
  border: 1px solid var(--light_gray_clr);
  border-radius: 50%;
  font-size: 18px;
  color: var(--light_gray_clr);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: auto;

  .fa-trash {
    color: #ff2159;
    cursor: pointer;
  }
}
</style>
